module.exports = __webpack_public_path__ + "static/media/claimStatus_right.698ad008.svg";